import { version } from './version';

export const environment = {
  production: true,
  endpoint: 'https://turnos-api.argentina.gob.ar/api/v1.0/',
  endpointTurnos: 'https://argentina.gob.ar/turnos',
  endpointmiargentina: 'https://mi.argentina.gob.ar/',
  argentinagobar: 'https://argentina.gob.ar/',
  version: version
};



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/environments/environment.ts